import { default as alta_45quotay2W6F1GxAaMeta } from "/opt/build/repo/pages/alta-quota.vue?macro=true";
import { default as indexzykjRX74mxMeta } from "/opt/build/repo/pages/contatti/form-failure/index.vue?macro=true";
import { default as indexeVcaUwsYG2Meta } from "/opt/build/repo/pages/contatti/form-success/index.vue?macro=true";
import { default as indexU71mUg00ZkMeta } from "/opt/build/repo/pages/contatti/index.vue?macro=true";
import { default as cookie_45policyZcRIsfqfIvMeta } from "/opt/build/repo/pages/cookie-policy.vue?macro=true";
import { default as etichettatura_45ambientaleCA6Eh4owI2Meta } from "/opt/build/repo/pages/etichettatura-ambientale.vue?macro=true";
import { default as index38Qe4v2f9JMeta } from "/opt/build/repo/pages/event/[slug]/index.vue?macro=true";
import { default as i_45tuoi_45eventiZxOrvAgFJuMeta } from "/opt/build/repo/pages/i-tuoi-eventi.vue?macro=true";
import { default as in_45cucinakbvAFWb3zwMeta } from "/opt/build/repo/pages/in-cucina.vue?macro=true";
import { default as in_45salaBxJ66yZbPXMeta } from "/opt/build/repo/pages/in-sala.vue?macro=true";
import { default as indexlaFeZuYZkUMeta } from "/opt/build/repo/pages/index.vue?macro=true";
import { default as oggi_45come_45ieriQeRITWsOcwMeta } from "/opt/build/repo/pages/oggi-come-ieri.vue?macro=true";
import { default as index6d9pOwjzxWMeta } from "/opt/build/repo/pages/piatti-e-vini/[category]/[slug]/index.vue?macro=true";
import { default as indexI6HOpdyw1mMeta } from "/opt/build/repo/pages/piatti-e-vini/[category]/index.vue?macro=true";
import { default as indexbyD3VfqYP5Meta } from "/opt/build/repo/pages/piatti-e-vini/index.vue?macro=true";
import { default as privacy_45policyQXTlhFuZ55Meta } from "/opt/build/repo/pages/privacy-policy.vue?macro=true";
import { default as indexmZue8RSC0IMeta } from "/opt/build/repo/pages/product/[slug]/index.vue?macro=true";
import { default as savoir_45fairecCqvmlVl4CMeta } from "/opt/build/repo/pages/savoir-faire.vue?macro=true";
import { default as sidri20q4JpYv59Meta } from "/opt/build/repo/pages/sidri.vue?macro=true";
import { default as take_45awayfXHEe0MbrVMeta } from "/opt/build/repo/pages/take-away.vue?macro=true";
import { default as component_45stubRU5sOBTecHMeta } from "/opt/build/repo/node_modules/nuxt/dist/pages/runtime/component-stub.js?macro=true";
import { default as component_45stubRU5sOBTecH } from "/opt/build/repo/node_modules/nuxt/dist/pages/runtime/component-stub.js";
export default [
  {
    name: "alta-quota___it",
    path: "/alta-quota",
    meta: alta_45quotay2W6F1GxAaMeta || {},
    component: () => import("/opt/build/repo/pages/alta-quota.vue").then(m => m.default || m)
  },
  {
    name: "alta-quota___en",
    path: "/en/high-altitude",
    meta: alta_45quotay2W6F1GxAaMeta || {},
    component: () => import("/opt/build/repo/pages/alta-quota.vue").then(m => m.default || m)
  },
  {
    name: "alta-quota___fr",
    path: "/fr/haute-altitude",
    meta: alta_45quotay2W6F1GxAaMeta || {},
    component: () => import("/opt/build/repo/pages/alta-quota.vue").then(m => m.default || m)
  },
  {
    name: "contatti-form-failure___it",
    path: "/contatti/errore-di-invio",
    meta: indexzykjRX74mxMeta || {},
    component: () => import("/opt/build/repo/pages/contatti/form-failure/index.vue").then(m => m.default || m)
  },
  {
    name: "contatti-form-failure___en",
    path: "/en/contacts/submission-error",
    meta: indexzykjRX74mxMeta || {},
    component: () => import("/opt/build/repo/pages/contatti/form-failure/index.vue").then(m => m.default || m)
  },
  {
    name: "contatti-form-failure___fr",
    path: "/fr/contacts/erreur-d-envoi",
    meta: indexzykjRX74mxMeta || {},
    component: () => import("/opt/build/repo/pages/contatti/form-failure/index.vue").then(m => m.default || m)
  },
  {
    name: "contatti-form-success___it",
    path: "/contatti/modulo-inviato",
    meta: indexeVcaUwsYG2Meta || {},
    component: () => import("/opt/build/repo/pages/contatti/form-success/index.vue").then(m => m.default || m)
  },
  {
    name: "contatti-form-success___en",
    path: "/en/contacts/form-sent",
    meta: indexeVcaUwsYG2Meta || {},
    component: () => import("/opt/build/repo/pages/contatti/form-success/index.vue").then(m => m.default || m)
  },
  {
    name: "contatti-form-success___fr",
    path: "/fr/contacts/formulaire-envoye",
    meta: indexeVcaUwsYG2Meta || {},
    component: () => import("/opt/build/repo/pages/contatti/form-success/index.vue").then(m => m.default || m)
  },
  {
    name: "contatti___it",
    path: "/contatti",
    meta: indexU71mUg00ZkMeta || {},
    component: () => import("/opt/build/repo/pages/contatti/index.vue").then(m => m.default || m)
  },
  {
    name: "contatti___en",
    path: "/en/contacts",
    meta: indexU71mUg00ZkMeta || {},
    component: () => import("/opt/build/repo/pages/contatti/index.vue").then(m => m.default || m)
  },
  {
    name: "contatti___fr",
    path: "/fr/contacts",
    meta: indexU71mUg00ZkMeta || {},
    component: () => import("/opt/build/repo/pages/contatti/index.vue").then(m => m.default || m)
  },
  {
    name: "cookie-policy___it",
    path: "/cookie-policy",
    meta: cookie_45policyZcRIsfqfIvMeta || {},
    component: () => import("/opt/build/repo/pages/cookie-policy.vue").then(m => m.default || m)
  },
  {
    name: "cookie-policy___en",
    path: "/en/cookie-policy",
    meta: cookie_45policyZcRIsfqfIvMeta || {},
    component: () => import("/opt/build/repo/pages/cookie-policy.vue").then(m => m.default || m)
  },
  {
    name: "cookie-policy___fr",
    path: "/fr/cookie-policy",
    meta: cookie_45policyZcRIsfqfIvMeta || {},
    component: () => import("/opt/build/repo/pages/cookie-policy.vue").then(m => m.default || m)
  },
  {
    name: "etichettatura-ambientale___it",
    path: "/etichettatura-ambientale",
    meta: etichettatura_45ambientaleCA6Eh4owI2Meta || {},
    component: () => import("/opt/build/repo/pages/etichettatura-ambientale.vue").then(m => m.default || m)
  },
  {
    name: "etichettatura-ambientale___en",
    path: "/en/etichettatura-ambientale",
    meta: etichettatura_45ambientaleCA6Eh4owI2Meta || {},
    component: () => import("/opt/build/repo/pages/etichettatura-ambientale.vue").then(m => m.default || m)
  },
  {
    name: "etichettatura-ambientale___fr",
    path: "/fr/etichettatura-ambientale",
    meta: etichettatura_45ambientaleCA6Eh4owI2Meta || {},
    component: () => import("/opt/build/repo/pages/etichettatura-ambientale.vue").then(m => m.default || m)
  },
  {
    name: "event-slug___it",
    path: "/event/:slug()",
    meta: index38Qe4v2f9JMeta || {},
    component: () => import("/opt/build/repo/pages/event/[slug]/index.vue").then(m => m.default || m)
  },
  {
    name: "event-slug___en",
    path: "/en/event/:slug()",
    meta: index38Qe4v2f9JMeta || {},
    component: () => import("/opt/build/repo/pages/event/[slug]/index.vue").then(m => m.default || m)
  },
  {
    name: "event-slug___fr",
    path: "/fr/event/:slug()",
    meta: index38Qe4v2f9JMeta || {},
    component: () => import("/opt/build/repo/pages/event/[slug]/index.vue").then(m => m.default || m)
  },
  {
    name: "i-tuoi-eventi___it",
    path: "/i-tuoi-eventi",
    meta: i_45tuoi_45eventiZxOrvAgFJuMeta || {},
    component: () => import("/opt/build/repo/pages/i-tuoi-eventi.vue").then(m => m.default || m)
  },
  {
    name: "i-tuoi-eventi___en",
    path: "/en/i-tuoi-eventi",
    meta: i_45tuoi_45eventiZxOrvAgFJuMeta || {},
    component: () => import("/opt/build/repo/pages/i-tuoi-eventi.vue").then(m => m.default || m)
  },
  {
    name: "i-tuoi-eventi___fr",
    path: "/fr/i-tuoi-eventi",
    meta: i_45tuoi_45eventiZxOrvAgFJuMeta || {},
    component: () => import("/opt/build/repo/pages/i-tuoi-eventi.vue").then(m => m.default || m)
  },
  {
    name: "in-cucina___it",
    path: "/in-cucina",
    meta: in_45cucinakbvAFWb3zwMeta || {},
    component: () => import("/opt/build/repo/pages/in-cucina.vue").then(m => m.default || m)
  },
  {
    name: "in-cucina___en",
    path: "/en/in-cucina",
    meta: in_45cucinakbvAFWb3zwMeta || {},
    component: () => import("/opt/build/repo/pages/in-cucina.vue").then(m => m.default || m)
  },
  {
    name: "in-cucina___fr",
    path: "/fr/in-cucina",
    meta: in_45cucinakbvAFWb3zwMeta || {},
    component: () => import("/opt/build/repo/pages/in-cucina.vue").then(m => m.default || m)
  },
  {
    name: "in-sala___it",
    path: "/in-sala",
    meta: in_45salaBxJ66yZbPXMeta || {},
    component: () => import("/opt/build/repo/pages/in-sala.vue").then(m => m.default || m)
  },
  {
    name: "in-sala___en",
    path: "/en/in-sala",
    meta: in_45salaBxJ66yZbPXMeta || {},
    component: () => import("/opt/build/repo/pages/in-sala.vue").then(m => m.default || m)
  },
  {
    name: "in-sala___fr",
    path: "/fr/in-sala",
    meta: in_45salaBxJ66yZbPXMeta || {},
    component: () => import("/opt/build/repo/pages/in-sala.vue").then(m => m.default || m)
  },
  {
    name: "index___it",
    path: "/",
    meta: indexlaFeZuYZkUMeta || {},
    component: () => import("/opt/build/repo/pages/index.vue").then(m => m.default || m)
  },
  {
    name: "index___en",
    path: "/en",
    meta: indexlaFeZuYZkUMeta || {},
    component: () => import("/opt/build/repo/pages/index.vue").then(m => m.default || m)
  },
  {
    name: "index___fr",
    path: "/fr",
    meta: indexlaFeZuYZkUMeta || {},
    component: () => import("/opt/build/repo/pages/index.vue").then(m => m.default || m)
  },
  {
    name: "oggi-come-ieri___it",
    path: "/oggi-come-ieri",
    meta: oggi_45come_45ieriQeRITWsOcwMeta || {},
    component: () => import("/opt/build/repo/pages/oggi-come-ieri.vue").then(m => m.default || m)
  },
  {
    name: "oggi-come-ieri___en",
    path: "/en/oggi-come-ieri",
    meta: oggi_45come_45ieriQeRITWsOcwMeta || {},
    component: () => import("/opt/build/repo/pages/oggi-come-ieri.vue").then(m => m.default || m)
  },
  {
    name: "oggi-come-ieri___fr",
    path: "/fr/oggi-come-ieri",
    meta: oggi_45come_45ieriQeRITWsOcwMeta || {},
    component: () => import("/opt/build/repo/pages/oggi-come-ieri.vue").then(m => m.default || m)
  },
  {
    name: "piatti-e-vini-category-slug___it",
    path: "/piatti-e-vini/:category()/:slug()",
    meta: index6d9pOwjzxWMeta || {},
    component: () => import("/opt/build/repo/pages/piatti-e-vini/[category]/[slug]/index.vue").then(m => m.default || m)
  },
  {
    name: "piatti-e-vini-category-slug___en",
    path: "/en/piatti-e-vini/:category()/:slug()",
    meta: index6d9pOwjzxWMeta || {},
    component: () => import("/opt/build/repo/pages/piatti-e-vini/[category]/[slug]/index.vue").then(m => m.default || m)
  },
  {
    name: "piatti-e-vini-category-slug___fr",
    path: "/fr/piatti-e-vini/:category()/:slug()",
    meta: index6d9pOwjzxWMeta || {},
    component: () => import("/opt/build/repo/pages/piatti-e-vini/[category]/[slug]/index.vue").then(m => m.default || m)
  },
  {
    name: "piatti-e-vini-category___it",
    path: "/piatti-e-vini/:category()",
    meta: indexI6HOpdyw1mMeta || {},
    component: () => import("/opt/build/repo/pages/piatti-e-vini/[category]/index.vue").then(m => m.default || m)
  },
  {
    name: "piatti-e-vini-category___en",
    path: "/en/piatti-e-vini/:category()",
    meta: indexI6HOpdyw1mMeta || {},
    component: () => import("/opt/build/repo/pages/piatti-e-vini/[category]/index.vue").then(m => m.default || m)
  },
  {
    name: "piatti-e-vini-category___fr",
    path: "/fr/piatti-e-vini/:category()",
    meta: indexI6HOpdyw1mMeta || {},
    component: () => import("/opt/build/repo/pages/piatti-e-vini/[category]/index.vue").then(m => m.default || m)
  },
  {
    name: "piatti-e-vini___it",
    path: "/piatti-e-vini",
    meta: indexbyD3VfqYP5Meta || {},
    component: () => import("/opt/build/repo/pages/piatti-e-vini/index.vue").then(m => m.default || m)
  },
  {
    name: "piatti-e-vini___en",
    path: "/en/piatti-e-vini",
    meta: indexbyD3VfqYP5Meta || {},
    component: () => import("/opt/build/repo/pages/piatti-e-vini/index.vue").then(m => m.default || m)
  },
  {
    name: "piatti-e-vini___fr",
    path: "/fr/piatti-e-vini",
    meta: indexbyD3VfqYP5Meta || {},
    component: () => import("/opt/build/repo/pages/piatti-e-vini/index.vue").then(m => m.default || m)
  },
  {
    name: "privacy-policy___it",
    path: "/privacy-policy",
    meta: privacy_45policyQXTlhFuZ55Meta || {},
    component: () => import("/opt/build/repo/pages/privacy-policy.vue").then(m => m.default || m)
  },
  {
    name: "privacy-policy___en",
    path: "/en/privacy-policy",
    meta: privacy_45policyQXTlhFuZ55Meta || {},
    component: () => import("/opt/build/repo/pages/privacy-policy.vue").then(m => m.default || m)
  },
  {
    name: "privacy-policy___fr",
    path: "/fr/privacy-policy",
    meta: privacy_45policyQXTlhFuZ55Meta || {},
    component: () => import("/opt/build/repo/pages/privacy-policy.vue").then(m => m.default || m)
  },
  {
    name: "product-slug___it",
    path: "/prodotto/:slug()",
    meta: indexmZue8RSC0IMeta || {},
    component: () => import("/opt/build/repo/pages/product/[slug]/index.vue").then(m => m.default || m)
  },
  {
    name: "product-slug___en",
    path: "/en/product/:slug()",
    meta: indexmZue8RSC0IMeta || {},
    component: () => import("/opt/build/repo/pages/product/[slug]/index.vue").then(m => m.default || m)
  },
  {
    name: "product-slug___fr",
    path: "/fr/produit/:slug()",
    meta: indexmZue8RSC0IMeta || {},
    component: () => import("/opt/build/repo/pages/product/[slug]/index.vue").then(m => m.default || m)
  },
  {
    name: "savoir-faire___it",
    path: "/savoir-faire",
    meta: savoir_45fairecCqvmlVl4CMeta || {},
    component: () => import("/opt/build/repo/pages/savoir-faire.vue").then(m => m.default || m)
  },
  {
    name: "savoir-faire___en",
    path: "/en/savoir-faire",
    meta: savoir_45fairecCqvmlVl4CMeta || {},
    component: () => import("/opt/build/repo/pages/savoir-faire.vue").then(m => m.default || m)
  },
  {
    name: "savoir-faire___fr",
    path: "/fr/savoir-faire",
    meta: savoir_45fairecCqvmlVl4CMeta || {},
    component: () => import("/opt/build/repo/pages/savoir-faire.vue").then(m => m.default || m)
  },
  {
    name: "sidri___it",
    path: "/sidri",
    meta: sidri20q4JpYv59Meta || {},
    component: () => import("/opt/build/repo/pages/sidri.vue").then(m => m.default || m)
  },
  {
    name: "sidri___en",
    path: "/en/ciders",
    meta: sidri20q4JpYv59Meta || {},
    component: () => import("/opt/build/repo/pages/sidri.vue").then(m => m.default || m)
  },
  {
    name: "sidri___fr",
    path: "/fr/cidres",
    meta: sidri20q4JpYv59Meta || {},
    component: () => import("/opt/build/repo/pages/sidri.vue").then(m => m.default || m)
  },
  {
    name: "take-away___it",
    path: "/take-away",
    meta: take_45awayfXHEe0MbrVMeta || {},
    component: () => import("/opt/build/repo/pages/take-away.vue").then(m => m.default || m)
  },
  {
    name: "take-away___en",
    path: "/en/take-away",
    meta: take_45awayfXHEe0MbrVMeta || {},
    component: () => import("/opt/build/repo/pages/take-away.vue").then(m => m.default || m)
  },
  {
    name: "take-away___fr",
    path: "/fr/take-away",
    meta: take_45awayfXHEe0MbrVMeta || {},
    component: () => import("/opt/build/repo/pages/take-away.vue").then(m => m.default || m)
  },
  {
    name: component_45stubRU5sOBTecHMeta?.name,
    path: "/it/",
    component: component_45stubRU5sOBTecH
  },
  {
    name: component_45stubRU5sOBTecHMeta?.name,
    path: "/sitemap.xml",
    component: component_45stubRU5sOBTecH
  }
]